import StudentAttendanceForm from "./StudentAttendanceForm";
import { CENTER, DATATABLE_EXPORT } from "../../../../../../../Config/ApiUrl";

export const StudentAttendanceSchema = {
	components: { StudentAttendanceForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "center-table",
			rowData: {},
			formId: "center-form",
			tableColumns: [
				{
					title: "Week",
					type: "text",
					key: "name",
				},
				{
					title: "Start Date",
					type: "text",
					key: "name",
				},
				{
					title: "End Date",
					type: "text",
					key: "name",
				},
				{
					title: "星期一",
					type: "custom-html",
					key: "name",
					isVisible: true,
					modifier: (value) => {
						let checked_yes = true
						let checked_no = false
						// return 2 radio buttons 'Yes' and 'No'
						return `<div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input" ${checked_yes}> <label class="custom-control-label" for="customRadioInline1">A</label> </div> <div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input" ${checked_no}> <label class="custom-control-label" for="customRadioInline2">P</label> </div>`;
					},
				},
				{
					title: "星期二",
					type: "custom-html",
					key: "name",
					isVisible: true,
					modifier: (value) => {
						let checked_yes = true
						let checked_no = false
						// return 2 radio buttons 'Yes' and 'No'
						return `<div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input" ${checked_yes}> <label class="custom-control-label" for="customRadioInline1">A</label> </div> <div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input" ${checked_no}> <label class="custom-control-label" for="customRadioInline2">P</label> </div>`;
					},
				},
				{
					title: "星期三",
					type: "custom-html",
					key: "name",
					isVisible: true,
					modifier: (value) => {
						let checked_yes = true
						let checked_no = false
						// return 2 radio buttons 'Yes' and 'No'
						return `<div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input" ${checked_yes}> <label class="custom-control-label" for="customRadioInline1">A</label> </div> <div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input" ${checked_no}> <label class="custom-control-label" for="customRadioInline2">P</label> </div>`;
					},
				},
				{
					title: "星期四",
					type: "custom-html",
					key: "name",
					isVisible: true,
					modifier: (value) => {
						let checked_yes = true
						let checked_no = false
						// return 2 radio buttons 'Yes' and 'No'
						return `<div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input" ${checked_yes}> <label class="custom-control-label" for="customRadioInline1">A</label> </div> <div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input" ${checked_no}> <label class="custom-control-label" for="customRadioInline2">P</label> </div>`;
					},
				},
                {
					title: "星期五",
					type: "custom-html",
					key: "name",
					isVisible: true,
					modifier: (value) => {
						let checked_yes = true
						let checked_no = false
						// return 2 radio buttons 'Yes' and 'No'
						return `<div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input" ${checked_yes}> <label class="custom-control-label" for="customRadioInline1">A</label> </div> <div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input" ${checked_no}> <label class="custom-control-label" for="customRadioInline2">P</label> </div>`;
					},
				},
                {
					title: "星期六",
					type: "custom-html",
					key: "name",
					isVisible: true,
					modifier: (value) => {
						let checked_yes = true
						let checked_no = false
						// return 2 radio buttons 'Yes' and 'No'
						return `<div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input" ${checked_yes}> <label class="custom-control-label" for="customRadioInline1">A</label> </div> <div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input" ${checked_no}> <label class="custom-control-label" for="customRadioInline2">P</label> </div>`;
					},
				},
			],
			ENDPOINT: CENTER,
			actionObj: {
				title: "Note",
				type: "action",
			},
			options: {
				name: "Center",
				url: CENTER,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "center-form",
					},
                    {
						title: this.$t("view"),
						icon: "eye",
						type: "page",
						url: "class/class-information",
						target: "", // _blank to open newtab
						uniqueKey: (rowData) => rowData.id,
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
